import { keyframes } from 'styled-components'

export const rotate360 = keyframes`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(365deg);
  }
`
